<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">{{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col cols="12" md="4" >
                      <label class="cj-label">Nome</label>
                      <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="reminderTypeForm.name" :disabled="!((reminderTypeForm.id == null && canAdd) || (reminderTypeForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="4" >
                      <label class="cj-label">Gênero do termo</label>
                      <multiselect v-model="reminderTypeForm.term" :options="termOptions" track-by="name" label="name" :preselect-first="true" :showLabels="false" :allow-empty="false" :searchable="false" :disabled="!((reminderTypeForm.id == null && canAdd) || (reminderTypeForm.id != null && canEdit))"></multiselect>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer clearfix" v-if="(reminderTypeForm.id == null && canAdd) || (reminderTypeForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveReminderType">Salvar</b-button>
                  <b-button variant="danger" class="mr-3" v-if="reminderTypeForm.id != null && canRemove" @click="deleteReminderType">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: 'tipo de lembrete',
        termPlural: 'tipos de lembrete',
        url: 'tipos-de-lembrete',
        letter: 'o',
        newTerm: 'cadastrar-tipo-de-lembrete',
        module: 'reminder-types',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        reminderTypeForm: {
          id: null,
          name: '',
          term: null
        },

        termOptions: [
          { value: 'f', name: 'Feminino' },
          { value: 'm', name: 'Masculino' }
        ]
      }
    },
    async mounted () {
      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.canSee = true;
      this.canAdd = true;
      this.canEdit = true;
      this.canRemove = true;
      this.canManage = true;

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.eventBus.$emit('IS_LOADING', false);
        this.$router.push({ path: '/' });
      } else {
        if(this.$route.params.id != this.newTerm) {
          await this.api.getReminderType(this.$route.params.id).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            this.reminderTypeForm = {
              id: res.data.id,
              name: res.data.name,
              term: this.termOptions.find(term => term.value == res.data.term)
            };

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Reminder Type', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.$router.push({path: '/' + this.url});

            this.$swal('Ops...', 'Não conseguimos carregar este ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Reminder Type', err.response);
          });
        } else {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
        }
      }
    },
    methods: {
      async saveReminderType() {
        if(!this.canPerformAction || !((this.reminderTypeForm.id == null && this.canAdd) || (this.reminderTypeForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let reminderTypeData = {
          id: this.reminderTypeForm.id,
          name: this.reminderTypeForm.name,
          term: this.reminderTypeForm.term.value
        };

        this.eventBus.$emit('IS_LOADING', true);
        if (this.reminderTypeForm.id == null) {
          this.api.storeReminderType(reminderTypeData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$router.push({path: '/' + this.url});

              this.$swal('Uhull \\o/', 'O '+this.termSingular+' foi cadastradado com sucesso!', 'success');

            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar o '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Reminder Type', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos criar este '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Reminder Type', err.response);
          });
        } else {
          this.api.updateReminderType(this.reminderTypeForm.id, reminderTypeData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 200) {
              this.$router.push({path: '/'+this.url});

              this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi atualizada com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar o ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Reminder Type', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos atualizar este ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Reminder Type', err.response);
          });
        }
      },

      async deleteReminderType() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel)
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.deleteReminderType(this.reminderTypeForm.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.$router.push({path: '/'+this.url});

                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi excluída com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir o ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Reminder Type', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir este ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Reminder Type', err.response);
            });
        }
      },

      goBack() {
        this.$router.push({path: '/' + this.url});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }
  }
</style>
